import React, { useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import BackendHeader from "../component/BackendHeader";
import axiosInstance from "../axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import CustomerSelect from "./CustomerSelect";
import { API_URL_All } from "../api";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../redux/filterReducer";
import * as general from '../libs/general';
const API_URL = `${API_URL_All}/api/import-orders`; // Adjusted API URL

const AddOrder = () => {
  const [units, setUnits] = useState([]);
  const [lines, setLines] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [rateData, setRateData] = useState([]);  // Thêm state cho rateData
  const dispatch = useDispatch();
  useEffect(() => {
    // Retrieve filters from sessionStorage on component mount
    const storedFilters = sessionStorage.getItem('filters');
    if (storedFilters) {
      const parsedFilters = JSON.parse(storedFilters);
      dispatch(setFilters(parsedFilters));
      sessionStorage.setItem('filters', JSON.stringify(parsedFilters));
    }

  }, [dispatch]);

    const handleNavigation = () => {
        var backLink = general.getBackLink('/quan-li-don-hang');
        navigate(backLink);
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await fetch(`${API_URL_All}/api/users/all`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Lỗi API: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("Lỗi khi gọi API:", error.message || error);
      }
    };

    fetchCustomers();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchWithCheck = async (url) => {
          const response = await fetch(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
              Accept: "application/json",
            },
          });
          if (!response.ok) {
            console.error(`Error fetching ${url}:`, response.statusText);
            return []; // Return empty array to prevent JSON parse error
          }
          return response.json();
        };

        // Thêm URL mới cho rateData
        const [unitData, lineData, statusData, rateData] = await Promise.all([
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/2`),
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/1`),
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/3`),
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/4`),  // Fetch rateData
        ]);

        setUnits(unitData);
        setLines(lineData);
        setStatuses(statusData);
        setRateData(rateData);  // Lưu rateData vào state
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Validation Schema
  const validationSchema = Yup.object({
    name: Yup.string().required("Vui lòng nhập Tên sản phẩm"),
    userId: Yup.string().required("Vui lòng nhập Mã khách hàng"),
    lineId: Yup.string().required("Vui lòng nhập Line"),
    locked: Yup.boolean(), // Thêm validation cho checkbox locked
    // packageUnitValue: Yup.number()
    //   .typeError("Vui lòng nhập Khối lượng")
    //   .required("Khối lượng là bắt buộc"),
    insurancePrice: Yup.number()
      .typeError("Vui lòng nhập Giá bảo hiểm")
      .required("Giá bảo hiểm là bắt buộc"),
    //    packageUnitM3: Yup.number()
    // .typeError("Vui lòng nhập Khối lượng m3")
    // .required("Khối lượng m3 là bắt buộc"), // Make packageUnitM3 required
  });

  const handleSubmit = async (values, { resetForm }) => {
    try {
      // console.log("Form values before submit:", values);
      const response = await axiosInstance.post(API_URL, values, {
        headers: { "Content-Type": "application/json" }, // Gửi JSON thay vì FormData
      });

      // console.log("Success:", response.data);
      toast.success("Thêm đơn hàng thành công!", { position: "top-right" });
      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Lỗi khi thêm đơn hàng!", { position: "top-right" });
    }
  };

  return (
    <div>
      <BackendHeader />
      <div className="container my-2">
        <h2 className="text-center mb-4">Thêm đơn hàng</h2>
        <Formik
          initialValues={{
            name: "",
            packageNumbers: "0",
            insurancePrice: "0",
            packageUnitValue: "0",
            supplementaryFee: "0",
            userId: "", // Thay vì emailCustomer
            shippingMethod: "",
            cnShippingCode: "",
            vnShippingCode: "",
            lineId: "",
        
            statusId: "",
            statusRateId: "", // Thêm statusRateId vào initialValues
            locked: false,// Thêm validation cho checkbox locked
            note: "",
            packageUnitM3: 0
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors }) => (
            <Form className="row g-3 fw-bold">
              <CustomerSelect
                customers={customers}
                setFieldValue={setFieldValue}
                error={errors.userId} // Truyền lỗi nếu có
                isDisabled={values.locked}
              />

              <div className="col-md-6"></div>

              <div className="col-md-6">
                <label className="form-label">
                  Line <span className="text-danger">*</span>
                </label>
                <Field as="select" className="form-control" name="lineId" disabled={values.locked} >
                  <option value="">--Chọn--</option>
                  {lines.map((line) => (
                    <option key={line.id} value={line.id}>{line.name}</option>
                  ))}
                </Field>
                <ErrorMessage name="lineId" component="div" className="text-danger" />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Tên sản phẩm <span className="text-danger">*</span>
                </label>
                <Field type="text" className="form-control" name="name" disabled={values.locked} />
                <ErrorMessage name="name" component="div" className="text-danger" />
              </div>

              <div className="col-md-6">
                <label className="form-label">Mã vận đơn Trung Quốc</label>
                <Field type="text" className="form-control" name="cnShippingCode" disabled={values.locked} />
              </div>

              <div className="col-md-6">
                <label className="form-label">Mã vận đơn Việt Nam</label>
                <Field type="text" className="form-control" name="vnShippingCode" disabled={values.locked} />
              </div>

            

              <div className="col-md-3">
                <label className="form-label">Số lượng kiện hàng</label>
                <Field type="number" className="form-control" name="packageNumbers" disabled={values.locked} min="0"/>
              </div>
<div className="col-md-2">
  <label className="form-label">M3 <span className="text-danger"></span></label>
  <Field
    type="number"
    className="form-control"
    name="packageUnitM3"
    disabled={values.locked}
    min="0"
    step="any"
  />
  <ErrorMessage name="packageUnitM3" component="div" className="text-danger" />
</div>
              <div className="col-md-2">
                <label className="form-label">Khối lượng <span className="text-danger"></span></label>
                <Field type="number" className="form-control" name="packageUnitValue" disabled={values.locked} min="0" step="any"/>
                <ErrorMessage name="packageUnitValue" component="div" className="text-danger" />
              </div>

              <div className="col-md-2">
                <label className="form-label">Giá bảo hiểm<span className="text-danger">*</span></label>
                <Field type="number" className="form-control" name="insurancePrice" disabled={values.locked} min="0" step="any"/>
                <ErrorMessage name="insurancePrice" component="div" className="text-danger" />
              </div>

              <div className="col-md-2">
                <label className="form-label">Phụ phí phát sinh</label>
                <Field type="number" className="form-control" name="supplementaryFee" disabled={values.locked} min="0" step="any"/>
              </div>

              <div className="col-md-6">
                <label className="form-label">Phương thức lấy hàng</label>
                <Field as="textarea" className="form-control" name="shippingMethod" disabled={values.locked} />
              </div>

              <div className="col-md-6">
                <label className="form-label">Lưu trình</label>
                <Field as="select" className="form-control" name="statusId" disabled={values.locked} >
                  {/* <option value="">--Chọn--</option> */}
                  {statuses.map((status) => (
                    <option key={status.id} value={status.id}>{status.name}</option>
                  ))}
                </Field>
              </div>
              <div className="col-md-6">
                <label className="form-label">Đối soát</label>
                <Field as="select" className="form-control" name="statusRateId" disabled={values.locked} onChange={e => setFieldValue("statusRateId", e.target.value)}>
                  {/* <option value="">--Chọn--</option> */}
                  {rateData.map((rate) => (
                    <option key={rate.id} value={rate.id}>{rate.name}</option>
                  ))}
                </Field>
              </div>
              <div className="col-md-6">
                <label className="form-check-label">Khóa đơn hàng</label>
                <br />
                <Field
                  type="checkbox"
                  className="form-check-input"
                  name="locked" // Field name
                  checked={values.locked} // Bind checkbox to Formik value
                  onChange={() => setFieldValue("locked", !values.locked)} // Toggle value on change
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Ghi chú</label>
                <Field
                  as="textarea"
                  className="form-control"
                  name="note"
                  disabled={values.locked} // Disable if locked
                />
                <ErrorMessage name="note" component="div" className="text-danger" />
              </div>
              <div className="col-12 text-center">
                <button type="submit" className="btn btn-success px-5 py-2 me-3">Thêm</button>
                <button className="btn btn-secondary py-2 me-3" onClick={handleNavigation}>Quay lại</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddOrder;
